import React, { useEffect, useRef } from 'react';
import HrRecording from '../../components/hr-recording';
import moment from 'moment';
function HRChart({ hrSvg, recordHr, record }) {
    const refSvg = useRef(null);
    useEffect(() => {
        if (refSvg.current) {
            refSvg.current.appendChild(hrSvg);
        }
    }, []);
    return (React.createElement("div", { className: 'wrap-hr-section page-break' },
        React.createElement("div", { className: "header-card pl-3 fs-4 cardio-in" }, "Recording Summary"),
        React.createElement("div", { className: 'hr-section' },
            React.createElement("div", { className: 'recording-section' },
                React.createElement("div", { className: 'info-bottom-recording cardio-in' },
                    React.createElement("p", { className: '' },
                        "Time:  ",
                        moment(record.start).format('MMM DD, YYYY, HH:mm'),
                        " - ",
                        moment(record.end).format('HH:mm')),
                    React.createElement("p", { className: '' },
                        "Recording Time: ",
                        Math.floor(record.total / 60),
                        " minutes ",
                        record.total % 60,
                        " seconds")),
                recordHr && React.createElement(HrRecording, { recordHr: recordHr }) /*cardio section*/),
            React.createElement("div", { ref: refSvg, className: 'heart_rate' })),
        React.createElement("div", { className: 'wrap-append-text first-page' },
            React.createElement("p", { className: 'mb-1' },
                React.createElement("span", { className: 'weight-5' }, "PI (Perfusion Index)"),
                " - The ratio of the pulsatile blood flow to the non-pulsatile blood flow."),
            React.createElement("p", { className: 'mb-0' },
                React.createElement("span", { className: 'weight-5' }, "PWV (Pulse Wave Velocity)"),
                " - The velocity at which the blood pulse propagates. It may be used by your physician to estimate the measure of arterial stiffness/health."))));
}
export default HRChart;
